import { FieldArrayWithId, useFieldArray, useFormContext } from "react-hook-form";
import { DataFileImportFormType } from "../DataFileImportEditorUtils";
import { Box } from "@mui/material";
import VirtualizedList from "../../../../components/virtualized-list/VirtualizedList";
import { DataFileImportItemListItem } from "./DataFileImportItemListItem";
import { IKeyValuePair } from "../../../../common/models/KeyValuePair";
import NoData from "../../../../components/no-data/NoData";
import { t } from "i18next";

export type DataFileImportItemListProps = {
    name: 'tagTypeMap' | 'objectMap',
    pickList: IKeyValuePair<number, string>[]
};

export default function DataFileImportItemList({
    name,
    pickList
}: DataFileImportItemListProps) {

    const {
        watch,
        control,
    } = useFormContext<DataFileImportFormType>();    

    const {
        fields,
    } = useFieldArray({
        control: control,
        name: name,
        keyName: "fieldKey"
    });    

    const watchItems = watch(name);

    const listItems = fields.map((field, index) => {
        return {
            ...field,
            ...watchItems[index],
            fieldKey: `${name}.${index}-item`
        };
    });

    function renderItem(_index: number, item: FieldArrayWithId<DataFileImportFormType, 'tagTypeMap', 'fieldKey'>) {
        return (
            <DataFileImportItemListItem
                name={name}
                item={item}
                pickList={pickList}
                key={item.fieldKey}
            />
        );
    };

    return (
        
        watchItems.length > 0 ? <Box sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
            overflowY: 'auto',
            }}>

                                    
            <VirtualizedList
                items={listItems}
                renderItem={renderItem}
            />

        </Box> :
        <NoData text={t('dataFileImport.nodata.noItemsAvailable')} />

    );
}

